import { ThemeProperties } from '../../../core';

export interface InputComboboxTheme {
	triggerFontColor: string;
	triggerIconColor: string;
	triggerSelectedFont: string;
	triggerSelectedBackground: string;

	contentBackground: string;
	contentBorderRadius: string;
	contentBorderColor: string;
	contentBoxShadow: string;
	contentFontColor: string;

	inputIconColor: string;
	inputFont: string;
	inputBorderColor: string;
	inputHeight: string;

	emptyFont: string;
	emptyFontColor: string;
	emptyPadding: string;

	itemFont: string;
	itemFontColor: string;
	itemBorderRadius: string;
	itemMinHeight: string;
	itemPadding: string;
	itemFocusColor: string;
	itemHoverBackground: string;
	itemSelectedFont: string;
	itemSelectedBackground: string;
	itemSubLabelFont: string;
	itemSubLabelFontColor: string;
	itemStatusOnlineColor: string;
	itemStatusOfflineColor: string;
	itemStatusRingColor: string;

	actionsBackground: string;
	actionsPadding: string;
	actionsGap: string;
}

export const theme = new ThemeProperties('inputCombobox');
